import * as React from 'react';
import { IApplicationContext } from '../../types/applicationContext';

export const ApplicationContext = React.createContext<IApplicationContext>({} as IApplicationContext);
